var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download"},[_c('Download',{attrs:{"text":_vm.getText,"smallText":_vm.getSmallText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }